import { render, staticRenderFns } from "./LoginOrRegisterModal.vue?vue&type=template&id=62096c90&"
import script from "./LoginOrRegisterModal.vue?vue&type=script&lang=js&"
export * from "./LoginOrRegisterModal.vue?vue&type=script&lang=js&"
import style0 from "./LoginOrRegisterModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports